/* globals $ */
import { registerClass } from 'libs/ComponentLoader'
import he from 'he'

import {
  search,
  SEARCH_RESULTS
} from 'libs/rcmSearchApi'

import './styles.scss'

export const FILTER_CLICK = 'CompactResultsControls:filter_click'
export const SORT_CLICK = 'CompactResultsControls:sort_click'

class CompactResultsControls {
  constructor (element) {
    this.$el = $(element)

    this.$filterButton = this.$el.find('.compactResultsControls-filterButton')
    this.$sortButton = this.$el.find('.compactResultsControls-sortButton')

    this.$activeFilterList = this.$el.find('.compactResultsControls-activeFilterList')
    this.$filtersWrapper = this.$el.find('.compactResultsControls-filtersWrapper')
    this.$activeFilterTemplate = $(this.$el.find('.compactResultsControls-activeFilterTemplate').html())

    this.sortVal = ''
    this.$modalSortList = null

    this.resultsFilterModal = null

    this.updateInfo = this.updateInfo.bind(this)
    this.applySort = this.applySort.bind(this)
    this.cancelSort = this.cancelSort.bind(this)

    this.$filterButton.on('click', () => {
      this.$el.trigger(FILTER_CLICK)
    })
    this.$sortButton.on('click', () => {
      this.$el.trigger(SORT_CLICK)
    })

    this.$activeFilterList.on('click', '.activeFilterButton', this.removeFilter)

    search.on(SEARCH_RESULTS, this.updateInfo)
  }

  updateInfo () {
    this.setSort()
    this.setFilters()
  }

  setSort () {
    const {
      sortBy,
      sortOrder
    } = search

    this.sortVal = this.$sortButton.find('.compactResultsControls-sortType[data-default]').attr('data-value')

    if (sortBy) {
      this.sortVal = sortBy
      if (sortOrder) {
        this.sortVal += ':' + sortOrder
      } else {
        this.sortVal += ':asc'
      }
    }
    if (this.$modalSortList) {
      this.$modalSortList.find('.compactResultsControls-sortListItem').removeClass('selected')
      this.$modalSortList.find(`.compactResultsControls-sortListItem[data-value="${this.sortVal}"]`).addClass('selected')
    }

    this.$sortButton.find('.compactResultsControls-sortType').addClass('u--hide')
    this.$sortButton.find(`.compactResultsControls-sortType[data-value="${this.sortVal}"]`).removeClass('u--hide')
  }

  setFilters () {
    const {
      filters
    } = search

    let totalFilters = 0

    for (let attribute in filters) {
      const filter = filters[attribute]
      totalFilters += filter.items.length
    }

    if (totalFilters) {
      this.$filterButton.html(`${this.$filterButton.attr('data-button-filtered')}: ${totalFilters}`)
    } else {
      this.$filterButton.html(this.$filterButton.attr('data-button-title'))
    }
  }

  setButtons (params) {
    if (params.hasFilter) {
      this.$filterButton.removeClass('u--hide')
    } else {
      this.$filterButton.addClass('u--hide')
    }

    if (params.hasSort) {
      this.$sortButton.removeClass('u--hide')
    } else {
      this.$sortButton.addClass('u--hide')
    }
  }

  removeFilter (e) {
    const $button = $(e.currentTarget)
    const tag = he.decode($button.attr('data-tag'))
    $button.remove()

    search.removeFilter(tag)
  }

  applySort () {
    const $selectedItem = this.$modalSortList.find('.compactResultsControls-sortListItem.selected')
    const sortVal = $selectedItem.attr('data-value').split(':')
    const sortDirection = (sortVal.length > 1) ? sortVal[1] : ''
    const sortAttribute = sortVal[0]

    search.sort(sortAttribute, sortDirection)
  }

  cancelSort () {
    this.$modalSortList.find('.compactResultsControls-sortListItem').removeClass('selected')
    this.$modalSortList.find(`.compactResultsControls-sortListItem[data-value="${this.sortVal}"]`).addClass('selected')
  }

  getModalSortList () {
    if (this.$modalSortList) return this.$modalSortList

    this.$modalSortList = $(this.$el.find('.compactResultsControls-modalSortListTemplate').html())
    this.$modalSortList.find('.u--hide').removeClass('u--hide')
    this.$modalSortList.find(`.compactResultsControls-sortListItem[data-value="${this.sortVal}"]`).addClass('selected')

    this.$modalSortList
      .on('click', '.compactResultsControls-sortListItem', (e) => {
        const $element = $(e.currentTarget)
        this.$modalSortList.find(`.compactResultsControls-sortListItem`).removeClass('selected')
        $element.addClass('selected')
      })
      .on('keyup', '.compactResultsControls-sortListItem', (e) => {
        const $element = $(e.currentTarget)
        if (e.which === 13) {
          this.$modalSortList.find(`.compactResultsControls-sortListItem`).removeClass('selected')
          $element.addClass('selected')
        }
      })
    return this.$modalSortList
  }
}

registerClass('CompactResultsControls', CompactResultsControls)
